





























import { Vue, Component } from 'vue-property-decorator';
import routes from '@/router/routes';
import { Route } from '@/router/types';
@Component<NotFound>({
    name: 'NotFound',
})
export default class NotFound extends Vue {
    private similarTarget: Route | null = null;
    private threshold: number = 50;
    private accuracy: number = 5; // 작을 수록 정확

    private min(v1: number, v2: number, v3: number): number {
        let min = v1;
        if (min > v2) min = v2;
        if (min > v3) min = v3;
        return min;
    }

    private editDistance(a: string, b: string) {
        const diff = a.length > b.length ? (a.length - b.length) : (b.length - a.length);
        if (diff > this.threshold)
            return Number.MAX_VALUE;
    
        const m = a.length;
        const n = b.length;

        const d = Array(m+1).fill(0).map(()=>Array(n+1).fill(0));

        for (let i = 0; i < m; i++) {
            d[i][0] = i;
        }

        for (let j = 0; j < n; j++) {
            d[0][j] = j;
        }
        for (let j = 1; j < n; j++) {
            for (let i = 1; i < m; i++) {
                if (a[i] == b[j]) {
                    d[i][j] = d[i - 1][j - 1];
                } else {
                    d[i][j] = this.min(d[i - 1][j], d[i][j - 1], d[i - 1][j - 1]) + 1;
                }
            }
        }
        
        const result = d[m - 1][n - 1];
        return result === undefined ? 0 : result;
    }

    private find() {
        let min = Number.MAX_VALUE;
        let diffMin = Number.MAX_VALUE;
        let target: null | Route = null;
        routes.forEach((item: Route) => {
            const a = this.$route.path;
            const b = item.path;
            const now = this.editDistance(a, b);
            const diff = a.length > b.length ? (a.length - b.length) : (b.length - a.length);
            if (now < this.accuracy && diff < this.accuracy && now < min && diff < diffMin) {
                min = now;
                diffMin = diff;
                target = item;
            }
        });

        if (target) {
            const similar = target as Route;
            if (similar.name !== 'root') {
                this.similarTarget = similar;
            }
        }
    }

    private created() {
        this.find();
    }
}

